import React from 'react';

const DownloadIcon = (props) => {
  return <div {...props}>
    <img src={require('../../assets/download.svg')}/>
  </div>
}

export default DownloadIcon
